import mime from 'mime';
import knowledgeAPI from '@/api/knowledge.api.js';
/**
 * 知识库相关功能Mixin
 */
export default {
    data () {
        let currentKnowledge = null;
        let showKnowledgeFile = true;
        return { currentKnowledge, showKnowledgeFile };
    },
    computed: {
        modelListKnowledge () {
            let modelList = this.$store.state.appSettings.modelList;
            let knowledgeModel = modelList.find(item => item.value === 'knowledge');
            if (knowledgeModel) {
                return [knowledgeModel];
            } else {
                return [];
            }
        }
    },
    methods: {
        /**
         * 选择知识库
         */
        selectKnowledge () {
            this.model = 'knowledge';
            this.currentKnowledge = null;
            this.ui.showLeftMenu = true;
        },

        /**
         * 取消选择知识库
         */
        deselectKnowledge (sessionId) {
            this.model = 'commonMode';
            this.currentSessionId = sessionId;
            this.currentKnowledge = null;
            this.loadChat(sessionId); // 加载会话
            this.ui.showLeftMenu = true;
        },

        /**
        * 创建知识库对话
        */
        newKnowledgeChat (knowledge) {
            knowledge.url = this.parseFileUrl(knowledge.knowledgeUrl);
            this.currentKnowledge = knowledge;
            this.ui.showLeftMenu = true;

            this.newChat('knowledge');
        },

        /**
         * 获取知识库数据
         */
        async getKnowledgeData (knowledgeId) {
            let knowledge = await knowledgeAPI.getKnowledge(knowledgeId);
            if (knowledge && knowledge.data) {
                knowledge = knowledge.data;
                knowledge.url = this.parseFileUrl(knowledge.knowledgeUrl || knowledge.document.documentUrl);
                knowledge.knowledgeType = +knowledge.knowledgeType;
                this.currentKnowledge = knowledge;
                this.model = 'knowledge'; // 切换到知识库模式
            }
        },

        /**
         * 获取文件名的mimetype
         */
        getMimetype (name) {
            return mime.getType(name) || '';
        },

        /**
         * 获取文件名的对应的图标
         */
        getFileIcon (name) {
            let mimetype = mime.getType(name);
            if (!mimetype) {
                return 'el-icon-document';
            } else if (mimetype === 'application/pdf') {
                return 'iconfile-pdf-small';
            } else if (mimetype.indexOf('text') === 0) {
                return 'iconfile-txt-small';
            } else if (mimetype.indexOf('audio') === 0) {
                return 'iconfile-wav-small';
            }
        }

    }
};
